import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={s.wrap}>
        <div style={s.spinner}/>
        <p style={s.text}>Loading...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

const s = {
  wrap: {
    minHeight:'100vh', display:'flex', flexDirection:'column',
    alignItems:'center', justifyContent:'center',
    background:'#0e0e0d', gap:'14px',
    fontFamily:"'DM Sans',sans-serif",
  },
  spinner: {
    width:'28px', height:'28px',
    border:'2px solid #2a2927',
    borderTop:'2px solid #c49a3c',
    borderRadius:'50%',
    animation:'spin 0.7s linear infinite',
  },
  text: { fontSize:'13px', color:'#6b6966' },
};
